import { message }            from '@widesk-ui/hooks/useMessage';
import { functionalityStore } from '@/components/Functionality';
import { FunctionalityQuery } from '@/components/Functionality';
import { openUpgradePrompt }  from '@/components/Functionality/openUpgradePrompt';

const UNKNOWN_SUBSCRIPTION_MESSAGE = 'Impossible de vérifier votre abonnement pour le moment. Réessayez dans un instant.';

const blockOnUnknownSubscription = () => {
	message.error(UNKNOWN_SUBSCRIPTION_MESSAGE);

	return true;
};

export const openLimitUpgradePrompt = (query: FunctionalityQuery) => openUpgradePrompt({
	limit: functionalityStore.limit(query.reference),
	reference: query.reference,
	scope: functionalityStore.scopeOf(query.reference),
	usage: functionalityStore.usage(query),
});

export const isBlockedByLimit = async (query: FunctionalityQuery) => {
	try {
		if (!await functionalityStore.whenLimitReached(query)) return false;
	} catch {
		return blockOnUnknownSubscription();
	}

	openLimitUpgradePrompt(query);

	return true;
};

export const isBlockedFeature = async (reference: Account_FunctionalityReference) => {
	try {
		if (await functionalityStore.whenAvailable(reference)) return false;
	} catch {
		return blockOnUnknownSubscription();
	}

	openUpgradePrompt({ reference });

	return true;
};
